<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [menuComponent]="menuComponent"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <button
          type="button"
          *ngIf="formData.controls.length === 0"
          class="ir-btn ir-btn--title ir-txt--right"
          style="margin-bottom: 2em"
          (click)="importBobstContacts()"
        >
          <span>{{ 'plugins.installationbobstattendees.import-contacts' | translate }}</span>
        </button>
      </div>
      <div class="ir-content--modal th-content">
        <button
          type="button"
          *ngIf="formData.controls.length === 0"
          class="ir-btn ir-btn--title ir-txt--right"
          style="margin-bottom: 2em"
          (click)="importCustomerContacts()"
        >
          <span>{{ 'plugins.installationcustomerattendees.import-contacts' | translate }}</span>
        </button>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="signatures"
        *ngFor="let item of formData.controls; let i = index"
      >
        <div>
          <table class="ir-modal-table">
            <tr>
              <td></td>
              <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
                <i class="material-icons" (click)="openSignatureDeleteConfirm(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.type' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%" [formGroupName]="i">
                <div class="ir-form-group">
                  <input type="hidden" class="ir-form-set" formControlName="type" />
                  <div class="ir-line ir-select th-select" (click)="openTypeSelector(item.controls.type.value, i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.type.value && item.controls.type.value >= 0
                          ? (item.controls.type.value | signaturetype)
                          : ('plugins.installationsignature.select-type' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.firstName' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="firstName" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.lastName' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="lastName" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.function' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="jobFunction" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.place' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="place" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.date' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="date" formControlName="dateValue" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationsignature.signature' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <canvas-drawing
                  [data]="item.controls.signatureImage.value"
                  (drawing)="saveSignature($event, i)"
                ></canvas-drawing>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="addImports($event)" #importCustomersModal></modal>
<modal (modalOutput)="selectTypeMenu($event)" (modalClosed)="onClose($event)" #typesModal></modal>
<confirm
  #signatureDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
